import { GlobalData } from "../Common/GlobalData";
import { ReportDateHelper, TemplateHelpers } from "../Common/KendoHelpers";

export class StocksToBuySell {
    private static readonly GRID = '#grid';

    constructor() {
        this.init();
    }

    private init() {
        $(StocksToBuySell.GRID).kendoGrid({
            dataSource: {
                transport: {
                    read: GlobalData.URL_BASE +
                        GlobalData.URL_SUFFIX_PERSONAL_REPORTS_STOCKS_TO_BUY_SELL
                },
            },
            dataBound: function () {
                const data = $(StocksToBuySell.GRID).data('kendoGrid')!.dataSource.data();
                if (data && data.length > 0) {
                    ReportDateHelper.showReportDate(data[0].closingDate);
                }
            },
            height: 915,
            groupable: false,
            sortable: true,
            pageable: false,
            detailInit: this.openDetail,
            columns: [{
                field: 'symbol',
                title: 'Symbol',
                width: '100px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'buySell_Activity',
                title: 'BuySell<br>Activity',
                width: '100px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'buySell_Qty',
                title: 'BuySell<br>Qty',
                width: '60px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:n0}',
            }, {
                field: 'buySell_Price',
                title: 'BuySell<br>Price',
                width: '100px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:c2}',
            }, {
                field: 'closePrice',
                title: 'Close<br>Price',
                width: '100px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:c2}',
            }, {
                field: 'priceDiff',
                title: 'Price<br>Diff',
                width: '100px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template(TemplateHelpers.getColorCurrencyTemplate('priceDiff')),
            }, {
                field: 'costToPurchase',
                title: 'Cost to<br>Purchase',
                width: '100px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:c2}',
            }, {
                field: 'buySell_Account',
                title: 'BuySell<br>Account',
                width: '100px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
            }, {
                field: 'sumQtyOwn',
                title: 'Own<br>Qty',
                width: '50px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:n0}',
            }, {
                field: 'costPerShare',
                title: 'Own<br>Cost/Share',
                width: '100px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:c2}',
            }, {
                field: 'earningsPerShareDueDate',
                title: 'Earnings<br>Due Date',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template(TemplateHelpers.getFormattedDateTemplate('earningsPerShareDueDate')),
            }, {
                field: 'closingDate',
                hidden: true,
            }]
        });
    }

    private openDetail(e: any) {
        $("<div/>").appendTo(e.detailCell).kendoGrid({
            dataSource: {
                transport: {
                    read: GlobalData.URL_BASE +
                        GlobalData.URL_SUFFIX_PERSONAL_REPORTS_STOCKS_TO_BUY_SELL +
                        '/Detail?symbol=' + e.data.symbol
                },
                serverPaging: false,
                serverSorting: false,
                serverFiltering: false,
            },
            scrollable: false,
            columns: [
                {
                    field: 'companyName',
                    title: 'Company Name',
                    width: '190px',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12-left' },
                    attributes: { 'class': 'table-cell grid-cell-left' },
                },
                {
                    field: 'pivotPointData',
                    title: 'PivotPoint / PpPct',
                    width: '160px',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                },
                {
                    field: 'pivotNoteData',
                    title: 'PivotNote1 / StageA',
                    width: '200px',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                },
                {
                    field: 'technicalData',
                    title: 'Comp EPS RS SMR A/D Stable',
                    width: '250px',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                },
                {
                    field: 'industryData',
                    title: 'IBD Sector Industry Rank',
                    headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                    attributes: { 'class': 'table-cell grid-cell-center' },
                },
            ]
        });
    }
}
